export const resolvePermission = (
  givenPermissions: string[],
  wantedPermission: string[] | string,
) => {
  const permissons = typeof wantedPermission === 'string' ? [wantedPermission] : wantedPermission;

  const hasPermission = permissons?.find((v: string) => {
    const wPerms = v.split(' ');
    const wAction = wPerms[0];
    const wResource = wPerms[1];

    const found = givenPermissions?.find((n: string) => {
      // if the user has full access
      if (n === '*:*') return true;
      // if the user has full access to a give resource
      if (n === `${wResource}:*`) return true;
      // if the user has an action on all resources
      if (n === `*:${wAction}`) return true;
      // if the user has the specific permission
      return (n === v);
    });

    return typeof found !== 'undefined';
  });

  return typeof hasPermission !== 'undefined';
};

export default resolvePermission;
